import { Select, SelectItem } from '@mantine/core'
import { useEffect, useState } from 'react'
import { SelectProps } from '@mantine/core/lib/Select/Select'
import User from '@api/User'
interface IInputUser
    extends Omit<SelectProps & React.RefAttributes<HTMLInputElement>, 'data'> {
    data?: readonly (string | SelectItem)[]
    withAll?: boolean
}

interface ItemProps extends SelectItem {}

const InputUser = ({
    withAll = false,
    classNames,
    value,
    styles,
    unstyled,
    className,
    defaultValue,
    ...others
}: IInputUser) => {
    const { data } = User.useGetAllUsers({ limit: 1000 })
    const [list, setlist] = useState<ItemProps[]>([])
    useEffect(() => {
        if (data) {
            const selectlists = data.lists.map((e) => {
                return {
                    value: String(e.user_id),
                    label: e.user_fullname,
                }
            })
            if (withAll) {
                selectlists.unshift({
                    value: '',
                    label: 'ทั้งหมด',
                })
            }
            setlist(selectlists)
        }
        // eslint-disable-next-line
    }, [data])

    return (
        <Select
            key={list.length}
            className={className}
            label='ผู้ใช้งาน'
            value={String(value)}
            placeholder='ผู้ใช้งาน'
            data={list}
            filter={(value, item: ItemProps) =>
                item.label!.toLowerCase().includes(value.toLowerCase().trim())
            }
            {...others}
        />
    )
}

export default InputUser
